var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    hardline = _require$doc$builders.hardline,
    indent = _require$doc$builders.indent;

var printPreservingEmptyLines = require('./print-preserving-empty-lines');

var AssemblyBlock = {
  print: function print(_ref) {
    var options = _ref.options,
        path = _ref.path,
        _print = _ref.print;
    return concat(['{', indent(hardline), indent(printPreservingEmptyLines(path, 'operations', options, _print)), hardline, '}']);
  }
};
module.exports = AssemblyBlock;